import styled from "styled-components";

export const EmptyStateStyled = styled.div`
  background: var(--color-gray-50, #f6f6f7);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 8px 8px;

  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
